/** 
The main entry point for the Dresses Landing Page.

Referenced by the collection.dresses.liquid template.
**/
import ReactDOM from 'react-dom';
import './scss/templates/collection-dresses.scss';
import Breadcrumbs from './components/Breadcrumbs';
import Collection from './apps/collection-dresses/Collection';
import Hero from './apps/collection-dresses/Hero';
import OVApp from './utils/OVContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var _window$OV = window.OV,
    COLLECTION = _window$OV.COLLECTION,
    COLLECTION_ID = _window$OV.COLLECTION_ID;
var gridDisplaySwatches = COLLECTION.gridDisplaySwatches;

var init = function init() {
  ReactDOM.render( /*#__PURE__*/_jsxs(OVApp, {
    children: [/*#__PURE__*/_jsx(Breadcrumbs, {
      pageTitle: COLLECTION.title
    }), /*#__PURE__*/_jsx(Hero, {}), /*#__PURE__*/_jsx(Collection, {
      displaySwatches: gridDisplaySwatches,
      shopifyId: COLLECTION_ID
    })]
  }), document.getElementById('collection'));
};

init();